import {
  getAccountLanguage,
  globalTranslations,
  initTranslations,
  setLanguage,
} from '@futures-platform/i18n'

const localTranslations = {
  crowdSourcedEstimate: {
    en: `Crowd sourced estimate`,
    fi: `Joukkoistettu arvio`,
  },
  hasTagged: {
    en: `: Yes`,
    fi: `: On`,
  },
  hasNoTagged: {
    en: `: No`,
    fi: `: Ei ole`,
  },
  TagsPhenomenon: {
    en: `Tags`,
    fi: `Tageja`,
  },
  AddAndRemoveTags: {
    en: `Add / remove tags`,
    fi: `Lisää / poista tageja`,
  },
  TagsAddedAfterContentcardCreated: {
    en: `Tags can be added after the content card is created.`,
    fi: `Voit lisätä sisältökortille tageja, kun olet ensin luonut (tallentanut) sen.`,
  },
  AskingSaveTagsInEditorMode: {
    en: `You can now select the most suitable tags to the content. When done, please remember to SAVE your work!`,
    fi: `Tästä voit valita sisällöllesi sopivia tageja. Kun olet valmis, muista TALLENTAA työsi!`,
  },
  SaveBtnInEditorMode: {
    en: `SAVE`,
    fi: `TALLENNA`,
  },
  TitleTaggingSelector: {
    en: `Add / remove tags`,
    fi: `Lisää / Poista tageja`,
  },
  latestNewsTitle_Content_expl_view: {
    en: `Future news`,
    fi: `Tulevaisuusuutisia`,
  },
  Showtags: {
    en: `Show tags`,
    fi: `Näytä tagit`,
  },
  Maincontents: {
    en: `MAIN CONTENT`,
    fi: `MUUTOSILMIÖT`,
  },
  News: {
    en: `NEWS`,
    fi: `UUTISET`,
  },
  Share: {
    en: `Share`,
    fi: `Jaa`,
  },
  ShareInLinkedin: {
    en: `Share in LinkedIn`,
    fi: `Jaa LinkedInissä`,
  },
  ShareInTwitter: {
    en: `Share in Twitter`,
    fi: `Jaa Twitterissä`,
  },
  ShareinFacebook: {
    en: `Share in Facebook`,
    fi: `Jaa Facebookissa`,
  },
  Sharebyemail: {
    en: `Share by Email`,
    fi: `Jaa Sähköpostitse`,
  },
  openTheArticle: {
    en: `OPEN THE ARTICLE`,
    fi: `AVAA ARTIKKELI`,
  },
}
export const finalTranslations = { ...globalTranslations, ...localTranslations }

initTranslations(localTranslations)

setLanguage(getAccountLanguage())
